module.exports = __webpack_public_path__ + "static/media/Slugma_gaussian2.2eb9c83a.png";